const mounted = (el, binding) => {
  if (binding.value === false) return
  const f = function (evt) {
    evt.preventDefault()
    binding.value(evt, el)
  }
  el.addEventListener('click', f)
}

export default {
  mounted
}
